// I18N
export const I18N_DEFAULT_LANGUAGE: string = 'en';
export const I18N_SUPPORTED_LANGUAGES: string[] = ['it', 'en'];

// Error codes
export const ERROR_BOOKINGS_NOT_FOUND_CODE: string = 'BookingNotFound';
